import type { ReactNode } from 'preact/compat';
import type { CategoryBoundingBox, Product } from '../../../models/Product';
import ProductMiniature from '../../product/miniature/ProductMiniature';
import type { ProductMiniatureButtonsAction } from '../../product/miniature/ProductMiniatureButtons';
import ProductMiniatureList from '../../product/miniature/ProductMiniatureList';
import './MainFeatureHeader.less';
import ProductBoundingBoxMiniature from '../../product/miniature/ProductBoundingBoxMiniature';

export type MainFeatureHeaderProps = {
    preTitle: ReactNode;
    title: string;
    products?: Product[];
    imageUrl?: string;
    boundingBoxes?: CategoryBoundingBox[];
    selectedBoundingBox?: CategoryBoundingBox;
    imageWidth?: number;
    imageHeight?: number;
    visibleActions?: ProductMiniatureButtonsAction[];
};

const MainFeatureHeader = ({
    preTitle,
    title,
    products,
    imageUrl,
    boundingBoxes = [],
    selectedBoundingBox,
    imageWidth,
    imageHeight,
    visibleActions
}: MainFeatureHeaderProps) => (
    <div className="bri-MainFeatureHeader">
        <div className="bri-DisplayFont">{preTitle}</div>
        <div className="bri-MainFeatureHeader-title bri-Headline2Font">
            {title}
        </div>
        {products && products.length > 1 && (
            <ProductMiniatureList products={products} size="large" misaligned />
        )}
        {products && products.length === 1 && (
            <ProductMiniature
                product={products[0]}
                size="large"
                aspectRatio="1"
                clickable
                visibleActions={visibleActions}
            />
        )}
        {imageUrl && (
            <ProductBoundingBoxMiniature
                size="large"
                imageUrl={imageUrl}
                boundingBoxes={boundingBoxes}
                selectedBoundingBox={selectedBoundingBox}
                imageWidth={imageWidth}
                imageHeight={imageHeight}
            />
        )}
    </div>
);

export default MainFeatureHeader;
